export class InitFaqVideos {
  static readonly type = '[Faq] InitFaqVideos';
}
